// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as BehaviourMultiChoiceGroupedOptionContainer$LiteracyplanetTupperware from "./BehaviourMultiChoiceGroupedOptionContainer.res.mjs";

function PieceOfCakeMultiChoiceMultiResponseContainer(props) {
  return React.createElement(BehaviourMultiChoiceGroupedOptionContainer$LiteracyplanetTupperware.make, {
              questionIndex: props.questionIndex,
              responseOptionId: props.responseOptionId,
              children: props.children
            });
}

var make = PieceOfCakeMultiChoiceMultiResponseContainer;

var $$default = PieceOfCakeMultiChoiceMultiResponseContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
